import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import { KontentRichText } from '../../../types/KontentProps';

interface Props {
    kontentItemId?: string;
    code: KontentRichText;
}

const SocialShare: React.FC<Props> = ({ code, kontentItemId }) => {
    useEffect(() => {
        if (typeof window.ketch !== 'function') return;
        let scriptEl: HTMLScriptElement | null = null;
        window.ketch('on', 'consent', (consent: any) => {
            if (!consent.purposes.essential_services) return;
            if (scriptEl) return;
            let url = code.value;
            let urlString = strip_html_tags(url);
            urlString = urlString.replace('amp;', '');
            scriptEl = document.createElement('script');
            scriptEl.src = urlString;
            scriptEl.async = true;
            document.head.appendChild(scriptEl);
        });
        return () => {
            if (scriptEl) document.head.removeChild(scriptEl);
        };
    }, []);

    function strip_html_tags(str: any) {
        if (str === null || str === '') return false;
        else return str.replace(/<[^>]*>/g, '');
    }

    return <div data-kontent-item-id={kontentItemId}></div>;
};
export default SocialShare;

export const fragmentSocialShare = graphql`
    fragment SocialShare on kontent_item_component___social_share {
        elements {
            code {
                value
            }
        }
    }
`;
